import { inject, Injectable } from '@angular/core';
import CryptoJS from 'crypto-js';

@Injectable({ providedIn: 'root' })
export class StorageCryptoService {

  // Get the SECRET_KEY dynamically
  private get SECRET_KEY() {
    return 'fms_poc@2026_AES_256_K#91xLpZ!';
  }

  encrypt(data: unknown): string {
    return CryptoJS.AES.encrypt(JSON.stringify(data), this.SECRET_KEY).toString();
  }

  decrypt<T>(cipherText: string | null): T | null {
    if (!cipherText) return null;

    try {
      const bytes = CryptoJS.AES.decrypt(cipherText, this.SECRET_KEY);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);
      return decrypted ? (JSON.parse(decrypted) as T) : null;
    } catch {
      return null;
    }
  }

  setItem(key: string, value: unknown): void {
    localStorage.setItem(key, this.encrypt(value));
  }

  getItem<T>(key: string): T | null {
    return this.decrypt<T>(localStorage.getItem(key));
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  clear(): void {
    localStorage.clear();
  }
}
